import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="scroll-to"
export default class extends Controller {
  static values = {
    target: String,
    clickSelector: String
  }

  scrollAndClick(event) {
    event.preventDefault()

    if (!this.hasTargetValue) return

    const self = this
    const $target = window.$(this.targetValue)

    if ($target.length) {
      window.$("html, body").animate(
        {
          scrollTop: $target.offset().top
        },
        1000,
        function() {
          // After scroll completes, trigger click if specified
          if (self.hasClickSelectorValue) {
            const clickElement = document.querySelector(self.clickSelectorValue)
            if (clickElement) {
              clickElement.click()
            }
          }
        }
      )
    }
  }
}
